import './App.css';
import React, {useRef, useState, useEffect} from 'react';
import { Flex, FloatButton, Typography, Result,  Button, ConfigProvider, Radio, Space, Modal, Form, Tag, Input, message, Divider } from 'antd';
import { ConsumablePartsComponent } from './components/ConsumablePartsComponent';
import { RotablePartsComponent } from './components/RotablePartsComponent';
import { FilterFleetComponent } from './components/FilterFleetComponent';
import { useSelector, useDispatch } from "react-redux";
import { setSearchText as consumeText, setSelectedFleet}  from './redux/consumeSlice';
import { setSearchText as rotableText } from './redux/rotableSlice';
import { MailOutlined, ExceptionOutlined, SearchOutlined } from '@ant-design/icons';
import { setPartType, setFilterPart } from './redux/partsSlice';
import FilterConsGroup from './components/FilterConsGroup';
import FilterRotGroup from './components/FilterRotGroup';
import { GetConsumeFleetGroup } from './redux/consumeThunk';
import { GetRotableFleetGroup } from './redux/rotableThunk';
import { useNavigate } from 'react-router-dom';
import { setSelectedFleet as consumefleet } from './redux/consumeSlice';
import { setSelectedFleet as rotablefleet } from './redux/rotableSlice';
import { setLoadingFleet as consumeLoading } from './redux/consumeSlice';
import { setLoadingFleet as rotableLoading } from './redux/rotableSlice';
import { sendMail } from './redux/mailThunk';

function App() {
  const selectParts = useSelector(state => state.partTypeState.partType);
  const selectedConFleet = useSelector(state => state.consumeState.selectedFleet);
  const selectedRotFleet = useSelector(state => state.rotableState.selectedFleet);
  const selectedConGroup = useSelector(state => state.consumeState.selectedGroup);
  const selectedRotGroup = useSelector(state => state.rotableState.selectedGroup);

  const [currentParts, setCurrentParts] = useState("");  
  const [currentFleet, setCurrentFleet] = useState([]);
  const [currentGroup, setCurrentGroup] = useState([]);
  const [onOffFlag, setOnOffFlag] = useState('disabled');
  const dispatch = useDispatch();
  const [current,setCurrent] = useState(selectParts);   
  const [openContact,setOpenContact] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [modalTerm, setModalTerm] = useState(false);
  const { Text, Paragraph } = Typography;
  const { TextArea } = Input;
  const navigate = useNavigate();

  const [subj, setSubj] = useState("Parts inquiry");
  const [step, setStep]  = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const searchConsume = (value, _e, info) =>{
    const setSearchAction = consumeText(value);
    dispatch(setSearchAction);
  }

  const searchRotable = (value, _e, info) =>{
    const setSearchAction = rotableText(value);
    dispatch(setSearchAction);
  }

  const changeTag = (e) => {        
      setCurrent(e.key);     
      const setTagsAction =  setPartType(e.key);
      dispatch(setTagsAction);           
   }
  
  const setSelectedPartType = (value) =>{    
    setCurrentParts(value);   
    if (value!=undefined&& value!==""){
      setOnOffFlag("enabled");
      setStep(2);
    }
    else {
      setOnOffFlag("disabled");
    }
    if (value!=undefined && value==="Consumable"){
      dispatch(consumeLoading(true));
    }
    else if (value!= undefined && value === "Rotable"){
      dispatch(rotableLoading(true));
    }
    const setPartsAction =  setFilterPart(value);
    dispatch(setPartsAction);    
  }

  const showModalTerm = () => {
    setModalTerm(true);
  }

  useEffect(() => {
    dispatch(consumefleet([]));
    dispatch(rotablefleet([]));
    const showTerm = localStorage.getItem("SHOWTERM");
    if (showTerm==undefined && showTerm!=="Y") {
      setModalTerm(true);
    }
    else {
      setModalTerm(false);
    }
  },[]);

  useEffect(() => {
    if (currentParts!=undefined && currentParts!=""){
      if (currentParts==="Consumable"){        
        setCurrentFleet(selectedConFleet);           
        const params = {'fleet': selectedConFleet };     
        const getConsumableAction = GetConsumeFleetGroup(params);
        dispatch(getConsumableAction).unwrap().then((resp) => {                    
        });        
        if (selectedConFleet.length > 0){
          setStep(3);
        }        
      }
      else if (currentParts==="Rotable") {
        setCurrentFleet(selectedRotFleet);
        const params = {'fleet': selectedRotFleet };
        const getRotableAction = GetRotableFleetGroup(params);
        dispatch(getRotableAction).unwrap().then((resp) => {                    
        });  
        if (selectedConFleet.length > 0){
          setStep(3);
        } 
      }
      else {
        setCurrentFleet([]);        
      }
    }   
  }, [selectedConFleet, selectedRotFleet]);


  useEffect(() => {
    if (currentParts!=undefined && currentParts!=""){
      if (currentParts==="Consumable"){
        setCurrentGroup(selectedConGroup);
      }
      else if (currentParts==="Rotable") {
        setCurrentGroup(selectedRotGroup);
      }
      else {
        setCurrentGroup([]);
      }
    }
  }, [selectedConGroup, selectedRotGroup]);

  const navigateToLanding = () => {
    dispatch(setPartType(currentParts));
    navigate(`${process.env.REACT_APP_PREFIX}/landing`);
  }

  const submitToMail = (values) => {
    values.PartTypes = selectParts;
    values.Fleets = currentFleet;
    values.Groups = currentGroup;
    const mailAction = sendMail(values);        
    dispatch(mailAction).unwrap().then((resp)=> {           
      console.log(resp);
      if (resp.status===200){
        setOpenContact(false);      
        setModal2Open(true);  
      }
      else {
        messageApi.open({
          type: 'error',
          content: 'Your email cannot be sent!',
        });
      }
    });
  }

  const cancelMail = () => {
    setOpenContact(false);
  }

  const handleCloseModal2 = () => {
    setModal2Open(false);
  }

  const closeModalTerm = () => {
    console.log('close');
    setModalTerm(false);
    localStorage.setItem("SHOWTERM", "Y");
  }

  const getApplicable = (applic) => {
    const tagItems = [];
    applic.map((val)=>{            
      tagItems.push(<Tag>{val}</Tag>)    
      }) 
    return (
     <>{tagItems}</>
    )      
  }

  const getGroup = (groups) => {
    const tagItems = [];
    groups.map((val) => {
      tagItems.push(<Tag>{val}</Tag>)    
    });
    return (
      <>{tagItems}</>
    )
  }

  const [consumeBG, setConsumeBG] = useState('rgba(0,0,0,0.2)');
  const enterConsume = () => {
    setConsumeBG('rgba(0,0,0,0.4)');
  }
  const leaveConsume = () => {
    setConsumeBG('rgba(0,0,0,0.2)');
  }

  const [rotableBG, setRotableBG] = useState('rgba(0,0,0,0.2)');
  const enterRotable = () => {
    setRotableBG('rgba(0,0,0,0.4)');
  }
  const leaveRotable = () => {
    setRotableBG('rgba(0,0,0,0.2)');
  }

  return (
    <>
        {contextHolder}
            <ConfigProvider
                theme={{
                  components: {
                    Modal:{
                      titleColor: '#3F075C',
                      titleFontSize: 24
                    }       
                  },
                  token: {
                    colorPrimary: '#52D97B'
                  }
                }}
              >  
              <Modal title={null}
                centered
                footer={null}
                open={modalTerm}
                onOk={closeModalTerm}
                onCancel={null}
                closeIcon={null}
                width={'60%'}
                >
                  <Flex vertical style={{marginTop:18,maxHeight:600,overflowY:'auto',paddingRight:10,scrollbarWidth:'thin'}}>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                      <Flex style={{justifyContent:'space-between', alignContent:'center'}}>
                        <Paragraph style={{fontWeight:600,fontSize:16}}>
                          TERMS AND CONDITIONS FOR SALE OF SURPLUS AIRCRAFT PARTS (October 2025 Update)
                        </Paragraph>
                        <img src="thaiLogo.png" width="90" height="27"/>
                      </Flex>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    1. <b>Objective</b><br/>
                     Thai Airways International Public Company Limited (“THAI”) invites interested parties (“Bidders”) to submit proposals for the purchase of surplus aircraft parts, which have been made available for sale on THAI’s parts sales website (thaitechnical.com/partsales). The surplus parts have been re-categorized into <b>eight groups</b> (see Section 2 below for details). <b>Interested bidders are invited to inspect the available parts on-site between 18 October 2025 and 15 November 2025</b> to review the inventory and supporting documentation prior to bid submission.
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                      The <b>official bidding process</b> is expected to be launched in <b>late November 2025</b>, with the final schedule and submission guidelines to be announced shortly via <a href="https://www.thaitechnical.com/partsales/">www.thaitechnical.com/partsales</a>.<br/>THAI encourages all interested parties to take advantage of this inspection period to prepare their offers in advance.
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    2. <b>Sale Format & Part Categories</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	<b>Part Cetegories</b>: THAI offers the surplus aircraft parts in bulk (lot basis), grouped into <b>eight categories</b> for this sale:<br/>
                        <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                          o	AIRCRAFT CONSUMABLE<br/>
                          o	ENGINE (GE) CONSUMABLE<br/>
                          o	ENGINE (PW) CONSUMABLE<br/>
                          o	ENGINE (RR) CONSUMABLE<br/>
                          o	AIRCRAFT ROTABLE<br/>
                          o	ROTABLE ENGINE (GE)<br/>
                          o	ROTABLE ENGINE (PW)<br/>
                          o	ROTABLE ENGINE (RR)<br/>
                        </pre>                      
                      	* Bidders may submit offers based on <b>Airbus, Boeing, or Common Parts.</b><br/><br/>
                      •	<b>Commercial Options</b>: Two purchasing options are available for participating bidders:<br/>
                        1. <b>Outright Sale</b> - The bidder proposes to purchase the parts outright for a fixed price (immediate sale). Ownership of the parts will transfer to the buyer upon full payment (see Section 7). Standard payment terms apply in this case (see Section 5).<br/>
                        2. <b>Consugment Model(3-Year)</b> - The bidder proposes a consignment arrangement (up to a 3-year term) where the parts remain the property of THAI and the bidder (as a consignment partner) will assist in selling the parts on THAI's behalf. Specific terms such as revenue sharing, consigmnent fees, and responsibilities for storage or logistics will be negotiated and agreed upon in a separate consignment agreement. No bulk purchase payment is required upfront under this model, but the consigmnent partner must remit sale proceed to THAI as per the agreed terms.<br/>
                           • THAI reserves the right to accept or reject any proposal at its sole discretion.                           
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    3. <b>Condition of Parts & Documentation</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	All aircraft parts are sold on an <b>"As-Is, Where-Is"</b> basis with <b>no warranties</b> of any kind regarding condition, functionality, or certification.<br/>
                      •	THAI shall provide a copy of the original airworthiness certificate (for example, an EASA Form 1, FAA 8130-3, or a Certificate of Conformity (CoC) traceable to THAI). Original certification may be available upon request, subject to additional fees.<br/>
                      •	Due to inventory fluctuations,tge actyak delivered quantity may vary by ±5% from the listed quantities. The awarded bidder shall not dispute or claim compensation for any shortage or excess within this ±5% tolerance range.<br/>
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    4. <b>Proposal Submission</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	<b>Submission Method:</b> Bidders must submit their proposals either through the designated online system or via email to <b>partsales@thaiairways.com</b>. Details instructions for submission are provided on the website.<br/>
                      •	<b>Offer Content</b>: Each proposal should clearly state the <b>total price</b> offered for the lot or category of parts the bidder is interested in; itemized pricing by individual part is not required. Bidders should also indicate their preferred <b>commercial option</b> (Outright purchase or Consignment) or propose a combination if applicable.
                      •	<b>Eligibility</b>: Bidders must not be a THAI's blacklist or disqualified vendor list. THAI reserves the right to verify the background of bidders.<br/>
                      • Bidders are advised to review the updated part listing on the website and, if possible, take advantage of the on-site inspection period (18 October-15 November 2025) before submitting their proposals. This will ensure that proposals are based on the most accurate understanding of the parts on offer.<br/>
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    5. <b>Payment Terms</b><br/>
                      <b>For Outright Sale Purchases:</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	A <b>30% deposit</b> of the total purchase price must be made <b>within 10 business days</b> of the award notification.<br/>
                      •	The remaining 70% of the purchase price shall be paid in two installments: <br/>
                        <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                          o	<b>50%</b> of the total price due upon the first scheduled delivery of the parts.<br/>
                          o	<b>Final 20%</b> due upon confirmation that the last batch o parts is ready for delivery.<br/>
                        </pre>
                      •	All payments shall be in <b>United States Dollars</b>, unless otherwise agreed in writing.<br/>
                      •	Failure to meet the payment schedule <b>may result in sale cancellation</b>, forfeiture of any deposits, and blacklisting of the awarded bidder.<br/>
                      </pre>
                      <b>For Consigment Model:</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	Payment terms for consigbment arrangement will be defined in the separate consignment agreement. In general, the consignment partner (bidder) is <b>not required to pay upfront</b> for the parts. Instead, the partner will <b>remit proceeds</b> to THAI as and when the parts are sold to end buyers, according to a pre-agreed revenue sharing or commission structure.<br/>
                      •	The consignment agreement will specify how and when payments of proceeds are made to THAI (for example, monthly or quarterly settlemets of any sold items) and any minimum performance requirements or targets.<br/>
                      •	If the consignment partner fails to fulfill the obligations as per the consignment agreement(e.g. not remitting proceeds, or no achieving any agreed-upon sales targets), THAI reserves the right to terminate the consignment arrangement and seek return of the parts or other remedies as appropriate.<br/>                      
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    6. <b>Delivery & Pick-up Terms</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	Buyers must collect purchased parts <b>within 15 business days</b> after confirmation of readiness.<br/>
                      •	If the buyer does not collect the parts within the 15-business-day period, storage fees will apply. If more than <b>30 days</b> pass without collection, THAI reserves the right to <b>dispose of or resell</b> the uncollected items without any refund or compensation to the buyer.<br/>
                      •	THAI will provide standard <b>packaging</b> for the parts and will issue the necessary <b>invoice</b> documentation. The buyer is responsible for arranging <b>shipping</b>, including all freight, insurance, and handling logistics, and for complying with any applicable <b>export regulations</b> for the parts. All costs related to shipment and export clearance are the buyer’s responsibility.<br/>
                      •	For consignment arrangements, specific delivery and storage terms will be set forth in the consignment agreement. In principle, parts may remain at THAI’s premises or be transferred to the consignment partner’s custody for the duration of the consignment. Responsibilities for storage, insurance, and delivery to eventual end-buyers will be allocated in the consignment contract. The consignment partner must ensure proper care of any parts in their custody and return or account for all parts at the end of the consignment period or upon request.<br/>
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    7. <b>Liability & Risk Transfer</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	For outright sales, <b>buyers must collect</b> the purchased parts within 15 business days after THAI notifies that the parts are ready for pickup. Collection will be from the designated THAI facility or warehouse, as informed in the award notification.<br/>
                      •	<b>Title and risk of loss transfer upon full payment</b>.<br/>
                      •	THAI is <b>not responsible for export restrictions</b> or legal compliance issues related to the parts.<br/>
                      </pre>
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    8. <b>Governing Law & Dispute Resolution</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	These terms and any resulting sale or agreement shall be governed by the laws of the <b>Kingdom of Thailand</b><br/>
                      •	Any disputes arising out of or in connection with this sale shall be resolved through the courts of Thailand, which shall have jurisdiction, unless both parties <i>mutually agree in writing</i> to an alternative dispute resolution method or jurisdiction. (All proceedings shall be conducted in the Thai language, unless otherwise agreed.)                      
                      </pre>                      
                    </Paragraph>
                    <Paragraph style={{fontFamily:'sans-serif'}}>
                    9. <b>THAI's Rights Reserved (Bid Rejection & Sale Cancellaion)</b><br/>
                      <pre style={{background:'transparent',border: 'none',margin:0,marginLeft:4, fontFamily:'sans-serif'}}>
                      •	THAI reserves the <b>absolute right</b> to accept or reject any bid or proposal, <b>for any reason or no reason</b>, at its sole discretion, without obligation to explain its decision to the bidder.<br/>
                      •	THAI also reserves the right to <b>cancel any awarded sale</b> (even after notifying a winning bidder) without incurring any liability, if the awarded bidder fails to comply with these terms and conditions or is found to have misrepresented information in their proposal. In such case, any payments or deposits made by the defaulting bidder may be forfeited, and THAI may offer the parts to other bidders or re-initiate the sale process as it sees fit.<br/>                   
                      </pre>
                    </Paragraph>                    
                    <Flex style={{padding:10,justifyContent:'flex-end'}}>
                      <ConfigProvider
                        theme={{                
                          components: {
                            Button: {
                              defaultBg: '#52D97B',
                              defaultColor: '#ffffff'
                            }
                          },
                          token: {
                            colorBgSolid: '#52D97B',
                            colorPrimaryBg: '#52D97B'                            
                          }
                        }}
                      >  
                        <Button color='green' size="middle" onClick={closeModalTerm} style={{width:'20%', fontWeight: 500}}>Accept</Button>
                      </ConfigProvider>
                    </Flex>
                  </Flex>
                </Modal>
              <Modal
                title={null}
                centered
                footer={null}
                open={modal2Open}
                onOk={handleCloseModal2}
                onCancel={handleCloseModal2}
                width={'40%'}
              >
                <Result
                    status="success"
                    title="Your email has been sent to THAI Airways."                                        
                  />
            </Modal> 
            <Modal
              title="Contact Us"
              centered
              footer={null}
              open={openContact}
              onOk={()=> setOpenContact(false)}
              onCancel= {()=> setOpenContact(false)}            
              width={{
                xs: '90%',
                sm: '80%',
                md: '70%',
                lg: '60%',
                xl: '50%',
                xxl: '40%',
              }}
            >              
              <Flex vertical style={{width:'95%', justifyContent:'centerd',padding:10}}>
                <Paragraph style={{fontSize:16, color:'#515151'}}>
                  <img src="thaiLogo.png" width="60" height="18"/><br/>
                  <Flex style={{flex:1, justifyContent:'space-between'}}>
                    <Space><Text>To: </Text><Text>partsales@thaiairways.com</Text></Space>             
                  </Flex>                  
                </Paragraph>                                
                <Form name="MailForm" layout="vertical" requiredMark="optional" onFinish={submitToMail}>                 
                  <Paragraph style={{fontSize:14}}>
                  &nbsp;&nbsp;As you have announced the selling of aircraft spare parts on your website, we are interested in the following parts group:                    
                  </Paragraph>
                  <Paragraph>
                    <Space style={{marginLeft:20}}><Text>Parts Type: </Text><Tag>{currentParts}</Tag></Space>
                  </Paragraph>
                  <Paragraph>
                    <Space style={{marginLeft:20}}><Text>Equipment Group: </Text><Text>{getGroup(currentGroup)}</Text></Space>
                  </Paragraph>
                  <Paragraph style={{fontSize:14}}>With the proposed price(USD) at :</Paragraph>
                  <Form.Item name="Price" >                    
                    <Input size="middle" placeholder='9,999 USD'/>
                  </Form.Item>
                  <Form.Item label="Adddional Conditions" name="Message">
                    <TextArea rows={3}/>
                  </Form.Item>
                  <Paragraph style={{fontSize:14}}>
                  &nbsp;&nbsp;Please contact us at the following email:
                  </Paragraph>
                  <Form.Item name="Email" rules={[{required: true, message: 'Please enter your email'}]}>
                    <Input size="middle" placeholder='e.g. customer@exchange.com'/>
                  </Form.Item>   
                  <Form.Item name="Address" rules={[{required: true, message: 'Please enter your company name and address'}]}>
                    <TextArea row={2} placeholder='Company name and address'/>
                  </Form.Item>                                  
                  <Form.Item>
                    <Flex style={{width:'100%',justifyContent: 'space-between',gap:10}}>
                      <Button block size="large" type="primary" htmlType='submit'>Submit</Button>
                      <Button block size="large" type="default" onClick={cancelMail}>Cancel</Button>
                    </Flex>                  
                  </Form.Item>
                </Form>
              </Flex>
            </Modal>
          </ConfigProvider>
          <ConfigProvider
                theme={{                  
                  token: {
                    colorBgElevated: 'rgba(255,255,255,0.25)',
                    colorText: 'rgba(0,0,0,0.5)'                    
                  }
                }}
              >              
          </ConfigProvider>
          <Flex vertical style={{gap:30, width: '55%', marginTop:85, marginLeft:'21.5%', background: '#ffffff', borderRadius:20, padding:20,paddingTop:30,paddingBottom:30}}>
            <Flex style={{flex:1, justifyContent:'center'}}>
              <Flex vertical style={{flex:1, justifyContent:'flex-start'}}>
                <Text style={{fontSize:20, fontWeight: 600}}>What parts type are you interested?</Text>
                <Text style={{fontSize:16, color:'#ababab'}}>Filtering parts with the following criterias.</Text>
              </Flex>
              <Flex style={{flex:1 ,justifyContent: 'flex-end',gap:10}}>
              <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        solidTextColor: '#000000'
                      }
                    },
                    token: {
                      colorPrimary: '#F5C300',               
                    },
                  }}
                >   
                  <Button color="primary" size="large" variant="solid" style={{color:'#000000'}} icon={<ExceptionOutlined style={{fontSize:18,color:'#000000'}}/>} iconPosition='end' target='_blank' href='GTC_THAI_SurplusSale.pdf'>Terms & Conditions</Button>
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: '#3F075C',                
                    },
                  }}
                >   
                  <Button color="primary" size="large" variant="solid" icon={<MailOutlined style={{fontSize:18}}/>} iconPosition='end' onClick={()=>setOpenContact(true)}>Contact Us</Button>
                </ConfigProvider>
              </Flex>
            </Flex>
            <Flex vertical style={{flex:1, justifyContent:'center', alignItems:'center'}}>
              <Flex vertical style={{width:'100%', justifyContent:'flex-start'}}>
                <Space>                   
                  {
                    (currentParts==undefined || currentParts=="")?     
                      (step===1)?
                      (<Button style={{backgroundColor:"rgba(82,217,128,0.2)", borderColor: "rgba(82,217,128,1)", color: "rgba(82,217,128,1)", fontWeight: 600, fontSize: 20}} shape="circle" size="large">1</Button>)                                        
                      :                
                      (<Button disabled color="default" variant='filled' shape="circle" size="large">1</Button>)
                    :                      
                      (<Button style={{backgroundColor:"rgba(82,217,128,1)", borderColor: "rgba(82,217,128,1)", color: "rgba(255,255,255,1)", fontWeight: 600, fontSize: 20}} shape="circle" size="large">1</Button>)                                        
                  }
                  <Flex vertical><Text style={{fontSize:18,fontWeight:600}}>Step 1</Text><Text style={{color:'#ababab'}}>Select a parts type.</Text></Flex>
                </Space>
              </Flex>
              <Flex vertical style={{width:'100%', justifyContent:'flex-start'}}>
                <Flex style={{width:'95%',height:110,paddingLeft:50,paddingTop:20}}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Radio: {     
                          buttonBg: '#cccccc',    
                          buttonCheckedBg: 'rgba(255,255,255,0.9)',                                           
                          colorPrimary: '#ffd600',
                          colorText: '#ffffff',
                          colorPrimaryActive: 'rgba(63,7,92,0.95)',
                          colorPrimaryHover: 'rgba(255,255,255,0.9)',                                                    
                        }           
                      },
                    }}
                  >   
                    <Radio.Group block style={{gap:20,width:'100%'}} onChange={(e)=>setSelectedPartType(e.target.value)}>
                      <div className="radio-wrapper" style={{ backgroundImage: 'url(consumable.png)', width: '45%', height: '120px', backgroundSize: 'auto', borderRadius: 12 }}>
                        <Radio.Button value="Consumable" style={{width:'100%', height:120, borderWidth:2, fontSize:currentParts==='Consumable'?'1.5rem':'1.4rem', fontWeight: currentParts==='Consumable'?600:500, paddingTop:40, background: currentParts==='Consumable'?'rgba(33,33,33,0.5)':consumeBG}} onMouseEnter={()=>enterConsume()} onMouseLeave={()=>leaveConsume()}>Consumable</Radio.Button>
                      </div>
                      <div className="radio-wrapper" style={{ backgroundImage: 'url(rotable.png)', width: '45%', height: '120px', backgroundSize: 'cover', borderRadius: 12 }}>
                        <Radio.Button value="Rotable" style={{width:'100%', height:120, borderWidth:2, fontSize:currentParts==='Rotable'?'1.5rem':'1.4rem', fontWeight: currentParts==='Rotable'?600:500, paddingTop:40, background: currentParts==='Rotable'?'rgba(33,33,33,0.5)':rotableBG}} onMouseEnter={()=>enterRotable()} onMouseLeave={()=>leaveRotable()}>Rotable</Radio.Button>
                      </div>
                    </Radio.Group>
                  </ConfigProvider>
                </Flex>
              </Flex>
            </Flex>           
            <Flex vertical style={{flex:1, minHeight:120, justifyContent:'center', alignItems:'center'}}>
              <Flex vertical style={{width:'100%', justifyContent:'flex-start'}}>
                <Space>                   
                  {
                    (currentGroup==undefined || currentGroup.length==0)?
                      (step===2)?
                      (<Button style={{backgroundColor:"rgba(82,217,128,0.2)", borderColor: "rgba(82,217,128,1)", color: "rgba(82,217,128,1)", fontWeight: 600, fontSize: 20}} shape="circle" size="large">2</Button>)        
                      :
                      (<Button disabled color="default" variant='filled' shape="circle" size="large">2</Button>)
                    :
                      (<Button style={{backgroundColor:"rgba(82,217,128,1)", borderColor: "rgba(82,217,128,1)", color: "rgba(255,255,255,1)", fontWeight: 600, fontSize: 20}} shape="circle" size="large">2</Button>)                                        
                  }
                  <Flex vertical><Text style={{fontSize:18,fontWeight:600}}>Step 2</Text><Text style={{color:'#ababab'}}>Select an equipment type.</Text></Flex>
                </Space>
              </Flex>
              <Flex  vertical style={{width:'100%', justifyContent:'flex-start', paddingTop:20,paddingLeft:30}}>
                {
                  (currentParts!=undefined && currentParts!=="")?
                    (currentParts==="Consumable")?
                      <FilterConsGroup/>
                    :(currentParts==="Rotable")?
                      <FilterRotGroup/>
                    :undefined
                  :undefined
                }
              </Flex>
            </Flex>
            <Flex  vertical style={{flex:1, justifyContent:'center', alignItems: 'center'}}>
              <Flex style={{width:'100%', justifyContent:'center',paddingInline:30}}>
                {
                  (onOffFlag==='disabled')?
                  <Button block disabled size="large" color="default" variant="solid" icon={<SearchOutlined/>} iconPosition='end'> Search</Button>:
                  <ConfigProvider
                    theme={{                 
                      token: {
                        colorPrimary: '#52D97B'
                      }
                    }}
                  >  
                  <Button block size="large" color="primary" variant="solid" onClick={navigateToLanding} icon={<SearchOutlined/>} iconPosition='end'>Search</Button>
                  </ConfigProvider>
                }
              </Flex>
            </Flex>
          </Flex>  
    </>                  
  );
}

export default App;
